import { Link as RouterLink } from "react-router-dom";
import styles from "./Link.module.scss";

export function Link(props) {
  return <RouterLink className={styles.link} {...props} />;
}
